const userVenueList = [];

export const selectedVenue = {};
export default {
  userVenueList: userVenueList,
  selectedVenue: selectedVenue,
};
